<div class="profile">
    <div class="container">
        <div class="row mt-3">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb fqg f18">
                    <li class="mr-3"><img src="/assets/images/icon-yurt.png" alt="home"></li>
                    <li class="breadcrumb-item"><a href="/index" class="mgl">ᠲᠡᠷᠢᠭᠦᠨ ᠨᠢᠭᠤᠷ</a></li>
                    <li class="breadcrumb-item"><a href="/writer" class="mgl">ᠵᠣᠬᠢᠶᠠᠭᠴᠢ ᠶᠢᠨ ᠥᠷᠥᠭᠡ</a></li>
                    <li aria-current="page" class="breadcrumb-item active"><span class="mgl">{{authorContent.authorName}}</span></li>
                </ol>
            </nav>
        </div>
        <div class="intro row mt-2 mb-5">
            <div class="col-4"><img alt="" class="rounded-sm float-left" src="{{url + authorContent.figure}}">
                <h4 class="mgl fgq f24 float-left">{{authorContent.authorName}} ({{authorContent.year}})</h4>
            </div>
            <div class="col-8 overflow-auto scrollbar_s" id="scrollX">
                <p class="mgl fhw f18">
                    <span class="fgq f18"> ᠲᠣᠪᠴᠢ ᠨᠠᠮᠲᠠᠷ᠄</span> {{aContent}}
                </p>
            </div>
        </div>
        <div class="row justify-content-center">
            <span class="col lpat"></span>
            <!-- <h4 class="col mgl catName justify-content-center fgq"> ᠲᠡᠭᠦᠨ ᠦ ᠪᠦᠲᠦᠭᠡᠯ</h4> -->
            <h4 class="col mgl catName justify-content-center fgq">ᠵᠣᠬᠢᠶᠠᠭᠴᠢ ᠶᠢᠨ ᠥᠷᠥᠭᠡ</h4>
            <span class="col lpat"></span>
        </div>
        <div class="row mb-5">
            <div class="row">
                <div class="col-6 col-sm-6 col-md-4 col-xl-2dot4 book media position-relative pl-0 mb-5" *ngFor="let al of authorList">
                    <img alt="" class="shadow mr-3 rounded-lg" style="height: 100%; width: 145px;" src="{{url + al.figure}}">
                    <div class="media-body mgl">
                        <h5 class="m-0 fgq f18">{{al.authorName}}</h5>
                        <a class="stretched-link" href="/author/{{al.authorId}}"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>